import { put, call } from 'redux-saga/effects';
import _ from 'lodash';
import * as API from '../../services/api';
import actionTypes from '../actionTypes';

export function* getTeamMembers({ teamId }) {
  try {
    const result = yield call(API.getTeamMembers, teamId);
    if (result.error) {
      yield put({ type: actionTypes.MEMBERS_GET_ERROR, error: result.error });
    } else {
      yield put({ type: actionTypes.MEMBERS_GET_SUCCESS, members: result });
    }
  } catch (error) {
    yield put({ type: actionTypes.MEMBERS_GET_ERROR, error });
  }
}

export function* createTeamMember({ member }) {
  try {
    const result = yield call(API.createTeamMember, member);
    if (result.error) {
      yield put({ type: actionTypes.MEMBER_CREATE_ERROR, error: result.error });
    } else {
      yield put({ type: actionTypes.MEMBER_CREATE_SUCCESS, member: result });
    }
  } catch (error) {
    yield put({ type: actionTypes.MEMBER_CREATE_ERROR, error });
  }
}

export function* updateTeamMember({ member }) {
  try {
    const result = yield call(API.updateTeamMember, member);
    if (result.error) {
      yield put({ type: actionTypes.MEMBER_UPDATE_ERROR, error: result.error });
    } else {
      yield put({ type: actionTypes.MEMBER_UPDATE_SUCCESS, member: result });
    }
  } catch (error) {
    yield put({ type: actionTypes.MEMBER_UPDATE_ERROR, error });
  }
}

export function* deleteTeamMember({ member }) {
  try {
    const result = yield call(API.deleteTeamMember, member);

    if (_.has(result, 'message') && result.message === false) {
      yield put({ type: actionTypes.MEMBER_DELETE_ERROR, error: null });
    } else {
      yield put({ type: actionTypes.MEMBER_DELETE_SUCCESS, member });
    }
  } catch (error) {
    yield put({ type: actionTypes.MEMBER_DELETE_ERROR, error });
  }
}

export function* createOwnership({ ownership }) {
  try {
    const result = yield call(API.createOwnership, ownership);
    if (result.error) {
      yield put({
        type: actionTypes.OWNERSHIP_CREATE_ERROR,
        error: result.error,
      });
    } else {
      yield put({
        type: actionTypes.OWNERSHIP_CREATE_SUCCESS,
        ownership: result,
      });
    }
  } catch (error) {
    yield put({ type: actionTypes.OWNERSHIP_CREATE_ERROR, error });
  }
}

export function* updateOwnership({ ownership }) {
  try {
    const result = yield call(API.updateOwnership, ownership);
    if (result.error) {
      yield put({
        type: actionTypes.OWNERSHIP_UPDATE_ERROR,
        error: result.error,
      });
    } else {
      yield put({
        type: actionTypes.OWNERSHIP_UPDATE_SUCCESS,
        ownership: result,
      });
    }
  } catch (error) {
    yield put({ type: actionTypes.OWNERSHIP_UPDATE_ERROR, error });
  }
}

export function* deleteOwnership({ ownership }) {
  try {
    yield call(API.deleteOwnership, ownership);
    yield put({ type: actionTypes.OWNERSHIP_DELETE_SUCCESS, ownership });
  } catch (error) {
    yield put({ type: actionTypes.OWNERSHIP_DELETE_ERROR, error });
  }
}

export function* updateUser({ user }) {
  try {
    const result = yield call(API.updateUser, user);
    if (result.error) {
      yield put({ type: actionTypes.USER_UPDATE_ERROR, error: result.error });
    } else {
      yield put({ type: actionTypes.USER_UPDATE_SUCCESS, user: result });
    }
  } catch (error) {
    yield put({ type: actionTypes.USER_UPDATE_ERROR, error });
  }
}

export function* getUser({ userId }) {
  try {
    const result = yield call(API.getUser, userId);
    if (result.error) {
      yield put({ type: actionTypes.USER_GET_ERROR, error: result.error });
    } else {
      yield put({ type: actionTypes.USER_GET_SUCCESS, user: result });
    }
  } catch (error) {
    yield put({ type: actionTypes.USER_GET_ERROR, error });
  }
}



// WEBPACK FOOTER //
// src/redux/sagas/users.js